/**
 * Core – News
 */

export default {
  news: {
    pageTitle: "Blog",
    pageSubtitle: "Here you can find latest news and articles written for you",
    dashboard: "Dashboard",
    blog: "Blog",
    show: "Show more",
    del: "Delete",
    sure: "Are you sure you want to delete the news",
    add: "Add news",
    news: "News",
  },
};
